import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Home from "components/home/Home";
import {
  selectWorklistItems,
  selectWorkStatus,
  selectIsLoading,
  selectError
} from "selector/workItemSelectors";
import {
  fetchWorkItemAction,
  selectWorkItemAction,
  changeWorklistFilter
} from "actions/fetchWorkItemsActions";
import { selectorsFor as sortingSelectorsFor } from "store/common/sorting/selectors";
import { actionsFor as sortingActionsFor } from "store/common/sorting/actions";
import types from "actions/actionTypes";
import {
  getColumnPickerVisibility,
  getWorkListColumnState,
  getWorkListColumnIDsByOrder
} from "selector/UISelectors";
import {
  setColumnActive,
  setColumnVisible,
  setColumnOrder,
  cloneWorkItemAction
} from "actions/workItemsActions";
import { getCurrentExternalId, getExternalIds } from "selector/userSelectors";

const SortingSelectors = sortingSelectorsFor("worklist");
const SortActions = sortingActionsFor("worklist");

function getColumnPickerOptions(state) {
  const columnState = getWorkListColumnState(state);

  if (selectWorkStatus(state) === "In Progress") {
    columnState["Actions"].visible = false;
  }

  return getWorkListColumnIDsByOrder(state)
    .filter(column => columnState[column].visible)
    .map((column, i) => ({
      id: column,
      active: columnState[column].active,
      order: i
    }));
}

const mapStateToProps = state => {
  const columnOptions = getColumnPickerOptions(state);
  return {
    loadingWorkItems: selectIsLoading(state),
    workItemError: selectError(state),
    items: selectWorklistItems(state),
    activeItem: selectWorkStatus(state),
    order: {
      field: SortingSelectors.getSortField(state),
      type: SortingSelectors.getSortType(state)
    },
    isColumnPickerVisible: getColumnPickerVisibility(state),
    columnOptions,
    columnConfig: columnOptions,
    userOffice: {
      current: getCurrentExternalId(state),
      options: getExternalIds(state)
    },
    currentWorkList: selectWorkStatus(state),
  };
};

const mapDispatchToProps = dispatch => {
  const actionCreators = bindActionCreators(
    {
      fetchData: fetchWorkItemAction,
      onClickItem: selectWorkItemAction,
      onClickClone: cloneWorkItemAction,
      onClickHeader: SortActions.changeSort,
      toggleColumnPicker: () => ({ type: types.TOGGLE_COLUMN_PICKER }),
      onColumnClick: item => setColumnActive(item.id, !item.active),
      onColumnOrderChange: (item, fromIndex, toIndex, workList) =>
        setColumnOrder(item.id, fromIndex, toIndex, workList),
      setUserOffice: office => ({
        type: types.SET_USER_OFFICE,
        payload: office
      })
    },
    dispatch
  );

  return {
    ...actionCreators,
    onTabChange(tabName) {
      dispatch(changeWorklistFilter({ name: "status", value: tabName }));
      dispatch(setColumnVisible("Actions", tabName !== "In Progress"));
    }
  };
};

const HomeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);

export default HomeContainer;
